import loadable from '@loadable/component';

export const InvoiceBillingAddressContainerLoadable = loadable(
  () => import('./InvoiceBillingAddressContainer'),
  {
    resolveComponent: (module) => module.InvoiceBillingAddressContainer,
  },
);
